import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_workinghrs_report = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year
  const storedBranch = localStorage.getItem("branch");
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Vehicle monthly working Hrs/Km", "view");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/vehicle_workinghrs_report_own`,
          {
            params: {
              branch_code: selectedBranch,
              year: selectedYear,
            },
          }
        );
        console.log(response);

        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles); // Initialize filtered data with all data
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch && selectedYear) {
      fetchData();
    }
  }, [selectedBranch, selectedYear]); // Re-run when branch or year changes

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.veh_name &&
          item.veh_name.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.veh_code &&
          item.veh_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.veh_type &&
          item.veh_type.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate("/vehicle_workinghrs_report_hire");
    }
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };


  const [site, setSite] = useState({
  ok: true,
  name: "Infraconsoft",
  logo: null,
  address: "",
  email: "",
  phone: "",
  _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) {
      console.error("Failed to load /siteinfo", e);
    }
  })();
  return () => { ignore = true; };
}, []);


  const exportToExcel = () => {
  // 1) Build your JSON rows exactly as before
  const exportData = filteredData.map((item, index) => ({
    "S.No": index + 1,
    Branch: storedBranch,
    VehicleName: item.veh_name,
    VehicleCode: item.veh_code,
    VehicleType: item.veh_type,
    "JAN Hrs": item.JAN1, "JAN Km": item.JAN,
    "FEB Hrs": item.FEB1, "FEB Km": item.FEB,
    "MAR Hrs": item.MAR1, "MAR Km": item.MAR,
    "APR Hrs": item.APR1, "APR Km": item.APR,
    "MAY Hrs": item.MAY1, "MAY Km": item.MAY,
    "JUN Hrs": item.JUN1, "JUN Km": item.JUN,
    "JUL Hrs": item.JUL1, "JUL Km": item.JUL,
    "AUG Hrs": item.AUG1, "AUG Km": item.AUG,
    "SEP Hrs": item.SEP1, "SEP Km": item.SEP,
    "OCT Hrs": item.OCT1, "OCT Km": item.OCT,
    "NOV Hrs": item.NOV1, "NOV Km": item.NOV,
    "DEC Hrs": item.DEC1, "DEC Km": item.DEC,
  }));

  // 2) Preserve your column order from the JSON keys (fallback if empty)
  const headers = exportData.length ? Object.keys(exportData[0]) : [
    "S.No","Branch","VehicleName","VehicleCode","VehicleType",
    "JAN Hrs","JAN Km","FEB Hrs","FEB Km","MAR Hrs","MAR Km",
    "APR Hrs","APR Km","MAY Hrs","MAY Km","JUN Hrs","JUN Km",
    "JUL Hrs","JUL Km","AUG Hrs","AUG Km","SEP Hrs","SEP Km",
    "OCT Hrs","OCT Km","NOV Hrs","NOV Km","DEC Hrs","DEC Km"
  ];

  // 3) Convert JSON -> AOA rows in the same header order
  const dataRows = exportData.map(row => headers.map(h => row[h] ?? ""));

  // 4) Company header + Title (merged across all columns)
  const COLS = headers.length;
  const fullWidth = (text = "") => [text, ...Array(COLS - 1).fill("")];
  const title = `Vehicle Working Hrs Report — ${selectedYear}`;

  const headerRows = [
    fullWidth((site.name || "Infraconsoft").toUpperCase()),
    fullWidth(site.address || ""),
    fullWidth(
      [site.phone ? `Ph: ${site.phone}` : "", site.email ? `Email: ${site.email}` : ""]
        .filter(Boolean)
        .join(" | ")
    ),
    [], // spacer
    fullWidth(title),
    [], // spacer
    headers,
  ];

  const aoa = [...headerRows, ...dataRows];

  // 5) Build worksheet from AOA
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);

  // Merges for the header lines
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLS - 1 } }, // company name
    { s: { r: 1, c: 0 }, e: { r: 1, c: COLS - 1 } }, // address
    { s: { r: 2, c: 0 }, e: { r: 2, c: COLS - 1 } }, // phone/email
    { s: { r: 4, c: 0 }, e: { r: 4, c: COLS - 1 } }, // title
  ];

  // Column widths (first few wider, months uniform)
  worksheet["!cols"] = headers.map((_, i) => {
    if (i === 0) return { wch: 6 };   // S.No
    if (i <= 4) return { wch: 18 };   // Branch/Name/Code/Type
    return { wch: 10 };               // Month cols
  });

  // Freeze after the header block (0..5 are header/spacer rows; row 6 has table header)
  worksheet["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // 6) Workbook + save (unchanged)
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicle Details");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  saveAs(blob, `vehicle_workinghrs_report-${selectedYear}.xlsx`);
};


  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  
  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">
            Vehicle-Monthly Working Hrs/Kms - Report(Own)
          </h2>
          <div>
            <Time />
          </div>
        </section>

        <div className="add-new-container">
          <button className="add-new-btn" onClick={exportToExcel}>
            <i className="fa-solid fa-file-excel"></i> Export to Excel
          </button>
        </div>

        <div className="vehicle-class">
          <div>
            <p>Year :</p>
            <select
              value={selectedYear}
              onChange={handleYearChange}
              required
              className="branch-select"
            >
              {Array.from(
                { length: currentYear - 2007 + 1 },
                (_, index) => currentYear - index
              ).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div>
            <p>Select your vehicle:</p>
            <select className="branch-select" onChange={handleSelection}>
              <option value="/own">Own Vehicle</option>
              <option value="/hire">Hire Vehicle</option>
            </select>
          </div>
        </div>

        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Vehicle Name</th>
                <th>Vehicle Code</th>
                <th>Vehicle Type</th>
                <th colSpan="2">{`JAN - ${currentYear}`}</th>
                <th colSpan="2">{`FEB - ${currentYear}`}</th>
                <th colSpan="2">{`MAR - ${currentYear}`}</th>
                <th colSpan="2">{`APR - ${lastYear}`}</th>
                <th colSpan="2">{`MAY - ${lastYear}`}</th>
                <th colSpan="2">{`JUN - ${lastYear}`}</th>
                <th colSpan="2">{`JUL - ${lastYear}`}</th>
                <th colSpan="2">{`AUG - ${lastYear}`}</th>
                <th colSpan="2">{`SEP - ${lastYear}`}</th>
                <th colSpan="2">{`OCT - ${lastYear}`}</th>
                <th colSpan="2">{`NOV - ${lastYear}`}</th>
                <th colSpan="2">{`DEC - ${lastYear}`}</th>
              </tr>
              <tr className="border">
                <th colSpan={5}></th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
                <th>Hrs</th>
                <th>Km</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{storedBranch}</td>
                    <td>{item.veh_name}</td>
                    <td>{item.veh_code}</td>
                    <td>{item.veh_type}</td>
                    <td>{item.JAN1}</td>
                    <td>{item.JAN}</td>
                    <td>{item.FEB1}</td>
                    <td>{item.FEB}</td>
                    <td>{item.MAR1}</td>
                    <td>{item.MAR}</td>
                    <td>{item.APR1}</td>
                    <td>{item.APR}</td>
                    <td>{item.MAY1}</td>
                    <td>{item.MAY}</td>
                    <td>{item.JUN1}</td>
                    <td>{item.JUN}</td>
                    <td>{item.JUL1}</td>
                    <td>{item.JUL}</td>
                    <td>{item.AUG1}</td>
                    <td>{item.AUG}</td>
                    <td>{item.SEP1}</td>
                    <td>{item.SEP}</td>
                    <td>{item.OCT1}</td>
                    <td>{item.OCT}</td>
                    <td>{item.NOV1}</td>
                    <td>{item.NOV}</td>
                    <td>{item.DEC1}</td>
                    <td>{item.DEC}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {/* Always show first page */}
          <button
            onClick={() => paginate(1)}
            className={currentPage === 1 ? "active" : ""}
          >
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [
              ...Array(
                Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1)
              ),
            ].map((_, index) => {
              const pageNumber = currentPage + index;
              if (
                pageNumber > 1 &&
                pageNumber <= Math.ceil(filteredData.length / itemsPerPage)
              ) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={currentPage === pageNumber ? "active" : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}

          {/* Next button */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredData.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_workinghrs_report;
